import Api from './api.service';

const ENDPOINT = 'contact-us';

export default {
  sendMessage: (data) => Api.post(ENDPOINT, data),
};
